import React from "react";
import PropTypes from "prop-types";

import MetaCell from "wxrecall/components/SearchResults/MetaCell";

import FormattedBulletin from "wxrecall/components/SearchResults/FormattedBulletin";

import If from "common/components/if";

/**
 * Renders a single table row, including metadata and bulletin text.
 */
export default function TableRow(props) {
  let rowClass = props.data.hasError ? "geometry-warning" : "";
  if (props.data.hidden) {
    rowClass += " hidden";
  }

  return (
    <tr className={rowClass}>
      <If condition={!!props.showMeta}>
        <td className="desktop-only">
          <MetaCell data={props.data} tab={props.tab} />
        </td>
      </If>
      <td>
        <FormattedBulletin
          data={props.data}
        />
      </td>
    </tr>
  );
}

TableRow.propTypes = {
  // The bulletin and metadata to be rendered
  data: PropTypes.object.isRequired,
  // True if the metadata column is to be rendered
  showMeta: PropTypes.bool,
  // A string containing the currently selected tab, either "weather" or "bulletin"
  tab: PropTypes.string,
};
